import { render } from "./VectorCoastersButton.vue?vue&type=template&id=5d5a61bc&scoped=true"
import script from "./VectorCoastersButton.vue?vue&type=script&lang=js"
export * from "./VectorCoastersButton.vue?vue&type=script&lang=js"

import "./VectorCoastersButton.vue?vue&type=style&index=0&id=5d5a61bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5a61bc"]])

export default __exports__